import { render, staticRenderFns } from "./EmblemEditorView.vue?vue&type=template&id=6033ade2&"
import script from "./EmblemEditorView.vue?vue&type=script&lang=js&"
export * from "./EmblemEditorView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports